/**
 *  指挥监控中心路由
 *  2018-4-13
 *  gao.kaizhi
 */
"use strict";
angular.module("commandMonitorRouterModule",
   ["planCommandManuscriptAnalysisRouterModule",
    "publicOpinionMgrZjRouterModule",
    "planCommandRegionalHotspotsRouterModule",
    "planCommandMonitorBeforeSelectTopicRouterModule",
    "mapSchedulingRouter",
    "planCommandMonitorClientPushManagementRouterModule",
    "planCommandCustomFunctionManageRouterModule",
    "planCommandMonitorAddFunctionRouterModule"]).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.planningresource.commandMonitor", {
        url: "/commandMonitor",
        views: {
            "main": {
                templateUrl: "./planningResource/commandMonitor/main_tpl.html",
                controller: "commandMonitorCtrl"
            }
        }
    }).
    state("front.planningresource.commandMonitor.basicManage", {
        url: "/basicManage",
        views: {
            "main@front.planningresource.commandMonitor": {
                templateUrl: "./planningResource/commandMonitor/basicManage/basicManage_tpl.html",
                controller: "planCommandMonitorBasicManageCtrl"
            }
        }
    }).
    state("front.planningresource.commandMonitor.oncepublicopinion", {
        url: '/oncepublicopinion',
        views: {
            'main@front.planningresource.commandMonitor': {
                templateUrl: './planningResource/commandMonitor/oncePublicOpinion/oncePublicOpinion_tpl.html',                           
                controller: 'planCommandMonitorOncePublicOpinionCtrl'
            }
        }
    });
}]);